import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    height: 52,
    flex: 1,
    display: "flex",
    flexDirection: "row-reverse",
    marginTop: 32,
    marginBottom: 32,
  },
  body: {
    width: 698,
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    borderRadius: 8,
    boxShadow: theme.palette.main.shadow.secondary,
  },
  title: {
    fontSize: 28,
    color: theme.palette.main.secondary.u1,
    textAlign: "center",
    marginBottom: 30,
  },
  iconContainer: {
    display: "flex",
    flexDirection: "row-reverse",
    marginTop: 20,
    marginRight: 37,
    marginBottom: 4,
  },
  listItemNumber: {
    color: theme.palette.main.secondary.o,
    marginRight: 8,
    fontSize: 16,
    fontWeight: "bold",
  },
  listItemText: {
    fontSize: 16,
    color: theme.palette.natural.t,
  },
  inputsContainer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 32,
    marginRight: 32,
  },
  listTitle: {
    fontSize: 18,
    color: theme.palette.natural.t,
    marginBottom: 16,
    fontWeight: "bold",
  },
  rowWithMargin: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 24,
  },
  infoRow: {
    display: "flex",
    flexDirection: "row",
    height: 34,
    alignItems: "center",
    marginBottom: 24,
    marginTop: 20,
  },
  infoIconContainer: {
    height: 34,
    width: 34,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dropdownContainer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 32,
    marginRight: 32,
  },
}));
